import { CancelledError } from '@tanstack/react-query'
import { refDataQueryOptions } from '../../../hooks/data/useRefData'
import { queryClient } from '../../../queryClient'
import type { RefData } from '../../../types/apiModels'

const ensureRefData = async (key: string): Promise<RefData[]> => {
  try {
    return await queryClient.ensureQueryData(refDataQueryOptions(key))
  } catch (error) {
    // This read may have joined a fetch owned by a useRefData observer, which React Query cancels
    // when that observer unmounts mid-flight; the rows are still needed here, so read them again.
    // Bounded to one re-read: a second cancellation propagates instead of retrying forever.
    if (!(error instanceof CancelledError)) throw error
    return queryClient.ensureQueryData(refDataQueryOptions(key))
  }
}

export async function findRefDataById(key: string, id: number | string) {
  const items = await ensureRefData(key)
  // RefData ids arrive as strings from some tables and numbers from others, while callers hold
  // whichever form their form state produced.
  return items.find(item => String(item.id) === String(id))
}
